import { buildUrl } from '../../../utils/api';

export const fetchEnterpriseIDPURL = () =>
  buildUrl('/api/v2/adm/enterprise-sso/identity-providers');

export const fetchEnterpriseOrgURL = (orgId: number) =>
  buildUrl(`/api/v2/adm/enterprise-sso/organization/${orgId}`);
